import React, { useCallback, useState } from 'react';
import { Bottom, FormButton, Main } from './styles';
import Button from '../../button';
import { createApiKey } from '../../../services/settingServices';
import { captureException } from '../../../services/logService';
import { BUTTON_TYPE } from '../../../global/constants';
import Input from '../../input';
import ModalHeader from '../modalHeader';

interface Props {
  onCancel: () => void;
  loadData: () => void;
}
const AddApiKeyModal: React.FC<Props> = (props) => {
  const { onCancel, loadData } = props;
  //States
  const [apiName, setApiName] = useState('');
  const [loading, setLoading] = useState(false);

  const onChangeInput = useCallback((name: string) => {
    setApiName(name);
  }, []);

  const onClickCancel = useCallback(() => {
    setApiName('');
    onCancel();
  }, [onCancel]);

  const onSubmit = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        setLoading(true);
        const result = await createApiKey(apiName);
        if (result) {
          onClickCancel();
          loadData();
        }
      } catch (error) {
        captureException(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [apiName, loadData, onClickCancel]
  );

  return (
    <Main onSubmit={onSubmit}>
      <ModalHeader title='Create API key' onClose={onClickCancel} />
      <Bottom>
        <Input
          label='Name (This is just for your reference)'
          placeHolder='Enter your key name'
          value={apiName}
          type='text'
          onChange={(e) => onChangeInput(e.target.value)}
        />
        <FormButton>
          <Button title='Cancel' variant={BUTTON_TYPE.SECONDARY} buttonType='button' onClick={onClickCancel} />
          <Button
            title='Create'
            variant={BUTTON_TYPE.PRIMARY}
            buttonType='submit'
            isLoading={loading}
            disabled={loading}
          />
        </FormButton>
      </Bottom>
    </Main>
  );
};

export default AddApiKeyModal;
